"use client";

import React from "react";
import { Droplets, Factory, Flame, Gem, Mountain, Pickaxe } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const industries = [{
  name: "Flue Gas Desulfurization",
  icon: Factory
}, {
  name: "Water Treatment",
  icon: Droplets
}, {
  name: "Petrochemical",
  icon: Flame
}, {
  name: "Gold Mining",
  icon: Gem
}, {
  name: "Nickel Mining",
  icon: Pickaxe
}, {
  name: "Platinum Mining",
  icon: Mountain
}];
const partners = [{
  name: "Bosch",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_bosch_logo.png"
}, {
  name: "Carl Hamm",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_carl_hamm_logo.png"
}, {
  name: "Putzmeister",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_putzmeister_logo.png"
}, {
  name: "ISOARC",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_isoarc_logo.png"
}, {
  name: "Global Tech",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_global_tech_logo.png"
}, {
  name: "Nexus Ind",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/partner_nexus_ind_logo.png"
}];
export default function IndustriesPartnerships() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return;
}